import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/gauge';

/**
 * * 仪表图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-11
 * Version: 1.0
 * Modify log:
 */
function IndexComponent(props) {

    const { rem, dataSource } = props;

    let dataObj = {};
    if (dataSource.length > 0) {
        dataObj = dataSource[0];
    }

    //为了防止除数为0报错，此时默认为1
    let { hjmc = '', hjblrs = 0, zrs = 1 } = dataObj;
    let percent = 0;

    percent = hjblrs / zrs * 100;

    let offsetAngle = -35;
    let totalAngle = 250; //仪表盘角度差值
    let startAngle = totalAngle + offsetAngle;
    let endAngle = startAngle - Math.floor(hjblrs / zrs * totalAngle);

    let series_sn_1 = 1;
    let series_sn_2 = 1;

    if(Math.floor(hjblrs / zrs * 100) == 0) {
        series_sn_1 = 0;
    }

    if((100 - Math.floor(hjblrs / zrs * 100)) == 0) {
        series_sn_2 = 0;
    }

    const option = {
        title: {
            text: '环节办理统计',
            textStyle: {
                color: '#05ffe3',
                fontSize: 0.18 * rem
            },
            itemGap: 20
        },
        series: [
            {
                name: '环节办理统计',
                type: 'gauge',
                radius: '70%',
                splitNumber: series_sn_1,
                startAngle: startAngle,
                endAngle: endAngle,
                title: {
                    fontSize: 0.14 * rem,
                    offsetCenter: [0, '-35%'],
                    color: '#00ffca'
                },
                detail: {
                    color: '#fce412',
                    fontSize: 0.36 * rem,
                    offsetCenter: [0, '15%'],
                    formatter: function (val) {

                        if(isNaN(val)) {
                            return '0%';
                        }

                        if (val == 0 || val == 100) {
                            return val + '%';
                        } else {
                            return val.toFixed(2) + '%';
                        }
                    },
                    rich: {
                        unit: {
                            fontSize: 0.1 * rem,
                            color: '#74dafc',
                            lineHeight: 0.3 * rem
                        }
                    }
                },
                axisLabel: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        opacity: 0
                    }
                },
                axisTick: {
                    length: 12,
                    splitNumber: Math.floor(hjblrs / zrs * 75),
                    lineStyle: {
                        width: 2,
                        color: '#00ffca',
                    }
                },
                splitLine: {
                    show: false
                },
                pointer: {
                    show: false
                },
                data: [
                    {
                        name: hjmc,
                        value: percent
                    }
                ]
            },
            {
                name: '',
                type: 'gauge',
                radius: '70%',
                splitNumber: series_sn_2,
                startAngle: endAngle,
                endAngle: offsetAngle,
                title: {
                    show: false
                },
                detail: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        opacity: 0
                    }
                },
                axisTick: {
                    length: 12,
                    splitNumber: 75 - Math.floor(hjblrs / zrs * 75),
                    lineStyle: {
                        width: 2,
                        color: '#2659aa',
                    }
                },
                splitLine: {
                    show: false
                },
                pointer: {
                    show: false
                }
            }
        ]
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <ReactEchartsCore
                style={{ width: '100%', height: '100%' }}
                echarts={echarts}
                option={option}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>
    );

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-bgy/LeftTopBox/_Gauge.js